// extracted by mini-css-extract-plugin
module.exports = {"title":"SystemSettings_title__3qA4r","button":"SystemSettings_button__1Fn8m","buttonWrapper":"SystemSettings_buttonWrapper__1aODr"};